/* THE SIGN — featured-carousel: tor produktów przewijający się w pętli.
   Progresywne ulepszenie — bez JS tor nadal przewija się ręcznie (scroll + swipe).
   JS dokłada trzy rzeczy:
     1. losową kolejność kart przy każdym wejściu na stronę,
     2. bezszwową pętlę (klon zestawu + reset scrollLeft o szerokość zestawu),
     3. ciągły automatyczny przesuw, pauzowany przy najechaniu, dotyku,
        fokusie klawiaturą i gdy karta przeglądarki jest w tle.
   Respektuje prefers-reduced-motion (wtedy: bez ruchu, bez klonów, zostaje snap).
   Vanilla JS, bez zależności. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Tasowanie Fisher–Yates — każde wejście na stronę daje inną kolejność. */
  function potasuj(lista) {
    for (var i = lista.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = lista[i];
      lista[i] = lista[j];
      lista[j] = tmp;
    }
    return lista;
  }

  function krok(track) {
    var item = track.querySelector('.featured-carousel__item');
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var szerokoscKarty = item.getBoundingClientRect().width + gap;
    /* Przewijamy o tyle całych kart, ile mieści się w torze — minimum jedną. */
    var naEkran = Math.max(1, Math.floor(track.clientWidth / szerokoscKarty));
    return szerokoscKarty * naEkran;
  }

  function init(scope) {
    var sections = (scope || document).querySelectorAll('.featured-carousel:not([data-carousel-ready])');

    Array.prototype.forEach.call(sections, function (section) {
      var track = section.querySelector('[data-carousel-track]');
      var nav = section.querySelector('[data-carousel-nav]');
      if (!track) return;

      section.setAttribute('data-carousel-ready', '');

      var oryginaly = Array.prototype.slice.call(track.querySelectorAll('.featured-carousel__item'));
      if (!oryginaly.length) return;

      /* --- 1. Losowa kolejność --------------------------------------------- */
      if (track.hasAttribute('data-carousel-shuffle')) {
        potasuj(oryginaly).forEach(function (item) {
          track.appendChild(item);
        });
      }

      var predkosc = parseFloat(track.getAttribute('data-carousel-speed')) || 0;
      var petla = predkosc > 0 && !reduceMotion;

      /* --- 2. Klon zestawu pod bezszwową pętlę ------------------------------ */
      var przesuniecie = 0;
      if (petla) {
        track.classList.add('is-autoplay');
        var klony = oryginaly.map(function (item) {
          var klon = item.cloneNode(true);
          /* Duplikat jest wyłącznie dekoracją — nie może trafiać do czytnika
             ekranu ani łapać fokusu, inaczej Tab przechodzi przez listę dwa razy. */
          klon.setAttribute('aria-hidden', 'true');
          klon.setAttribute('data-carousel-clone', '');
          Array.prototype.forEach.call(klon.querySelectorAll('a, button'), function (el) {
            el.setAttribute('tabindex', '-1');
          });
          track.appendChild(klon);
          return klon;
        });
        /* Dokładna szerokość jednego zestawu razem z odstępem — dzielenie
           scrollWidth na pół gubi ostatni gap i pętla po chwili dryfuje. */
        przesuniecie = klony[0].offsetLeft - oryginaly[0].offsetLeft;
      }

      /* --- 3. Automatyczny przesuw ----------------------------------------- */
      var wstrzymane = 0; // licznik nakładających się powodów pauzy
      var ostatniaKlatka = null;
      var reszta = 0; // ułamki piksela między klatkami
      /* Ile pikseli zostało do przewinięcia po kliknięciu strzałki. W trybie pętli
         nie da się użyć scrollBy({behavior:'smooth'}) — pętla co klatkę ustawia
         scrollLeft, co natychmiast przerywa animację przeglądarki i strzałki
         wyglądają na martwe. Dlatego ruch ze strzałki liczymy w tej samej pętli. */
      var recznyCel = 0;
      var PREDKOSC_RECZNA = 1400; // px/s — tyle, żeby skok był płynny, ale szybki

      function pauza() { wstrzymane += 1; }
      function wznow() {
        wstrzymane = Math.max(0, wstrzymane - 1);
        ostatniaKlatka = null;
      }

      function normalizuj() {
        if (!przesuniecie) return;
        if (track.scrollLeft >= przesuniecie) track.scrollLeft -= przesuniecie;
        else if (track.scrollLeft <= 0) track.scrollLeft += przesuniecie;
      }

      function klatka(czas) {
        if (!petla) return;
        window.requestAnimationFrame(klatka);
        if (document.hidden) { ostatniaKlatka = czas; return; }
        if (ostatniaKlatka === null) { ostatniaKlatka = czas; return; }

        var delta = (czas - ostatniaKlatka) / 1000;
        ostatniaKlatka = czas;
        /* Przeskok między klatkami bywa ogromny po powrocie z tła — ucinamy. */
        if (delta > 0.25) return;

        /* Ruch ze strzałki ma pierwszeństwo i działa też przy najechaniu myszą —
           inaczej kliknięcie strzałki (kursor nad sekcją = pauza) nic by nie dało. */
        if (recznyCel !== 0) {
          var kierunekReczny = recznyCel > 0 ? 1 : -1;
          var skok = Math.min(Math.abs(recznyCel), Math.max(1, PREDKOSC_RECZNA * delta));
          track.scrollLeft += skok * kierunekReczny;
          recznyCel -= skok * kierunekReczny;
          if (Math.abs(recznyCel) < 1) recznyCel = 0;
          normalizuj();
          return;
        }

        if (wstrzymane > 0) return;

        reszta += predkosc * delta;
        var pikseli = Math.floor(reszta);
        if (pikseli >= 1) {
          reszta -= pikseli;
          track.scrollLeft += pikseli;
          normalizuj();
        }
      }

      if (petla) {
        ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (zdarzenie) {
          track.addEventListener(zdarzenie, pauza, { passive: true });
        });
        ['mouseleave', 'focusout', 'pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (zdarzenie) {
          track.addEventListener(zdarzenie, wznow, { passive: true });
        });
        track.addEventListener('scroll', normalizuj, { passive: true });
        window.requestAnimationFrame(klatka);
      }

      /* --- 4. Strzałki ------------------------------------------------------ */
      if (!nav) return;
      var prev = nav.querySelector('[data-carousel-prev]');
      var next = nav.querySelector('[data-carousel-next]');
      if (!prev || !next) return;

      function przewin(kierunek) {
        if (petla) {
          /* Kolejne kliknięcia dokładają się do celu, zamiast kasować poprzedni skok. */
          recznyCel += krok(track) * kierunek;
          return;
        }
        track.scrollBy({
          left: krok(track) * kierunek,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }

      prev.addEventListener('click', function () { przewin(-1); });
      next.addEventListener('click', function () { przewin(1); });

      /* W pętli nie ma końca toru, więc strzałki nigdy się nie wygaszają.
         Bez pętli wygaszamy je na krańcach — 2px na zaokrąglenia subpikselowe. */
      function odswiezStrzalki() {
        if (petla) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      }

      function odswiezWidocznosc() {
        var wystaje = track.scrollWidth > track.clientWidth + 2;
        nav.hidden = !wystaje;
        if (wystaje) odswiezStrzalki();
      }

      track.addEventListener('scroll', odswiezStrzalki, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(odswiezWidocznosc).observe(track);
      } else {
        window.addEventListener('resize', odswiezWidocznosc);
      }

      odswiezWidocznosc();
    });
  }

  init(document);

  /* Edytor motywu: reinicjalizacja po ponownym wyrenderowaniu sekcji. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
